import styled from 'styled-components'
import { Button } from 'antd'
import { primaryColor } from 'assets/global'

export const Upload = styled.div`
  max-width: 800px;
  margin: 64px auto auto auto;
  text-align: center;
  @media (max-width: 600px) {
    max-width: 100%;
    margin: 24px 12px;
  }
`

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Dropzone = styled.div`
  width: 100%;
  max-width: 360px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 10px;
  background: transparent;
  color: var(--yrm-text);
  cursor: pointer;
  border: 1px dashed var(--yrm-border-strong);
  transition: transform .06s, border-color .12s, background .12s;
  font-weight: 500;
  font-size: 14px;
  svg { color: var(--yrm-text); }
  &:hover {
    transform: translateY(-1px);
    background: var(--yrm-surface-2);
    border-color: #bfbfbf;
  }
  &.active {
    border-color: #2a3cff;
    background: rgba(42,60,255,0.06);
  }
`;
export const UploadArea = styled.div`
  padding: 18px 20px;
  border: 1px dashed ${primaryColor};
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: transparent;
  transition: background .12s, border-color .12s, transform .08s;
  &:hover { background: var(--yrm-surface-2); transform: translateY(-1px); }
  &.active { border-color: #2a3cff; background: rgba(42,60,255,0.04); }
  @media (max-width: 600px) {
    padding: 12px 14px;
    border-radius: 8px;
  }
`

export const LoadingContainer = styled.div`
  text-align: center;
  padding: 40px 20px;
  
  p {
    margin-top: 16px;
    color: var(--yrm-text-3);
  }
`;

export const DocumentInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  
  svg {
    font-size: 16px;
  }
  
  span {
    color: var(--yrm-text);
    font-weight: 500;
  }
`;

export const UploadButton = styled(Button)`
  width: 100%;
  max-width: 220px;
  height: 42px;
  margin: 64px auto 64px auto;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const UploadError = styled.p`
  text-align: center;
  color: #dc3545;
  margin-bottom: 1rem;

  @media (max-width: 361px) {
    font-size: 14px;
  }
`

export const FileList = styled.div`
  width: 100%;
  margin-top: 12px;
  max-width: 520px;
`;

export const FileItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid var(--yrm-border);
`;

export const SuccessBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #2b7a0b;
  font-weight: 600;
`;

// responsividade aplicada diretamente nos componentes acima
